"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forwardTernAsync = exports.forwardIfAsync = exports.forwardTern = exports.forwardIf = exports.forward = void 0;
const Either_1 = require("../effects/Either");
const Maybe_1 = require("../effects/Maybe");
const forward = (forward, ...fs) => fs.reduce((a, f) => f(forward), []);
exports.forward = forward;
const forwardIf = (forward, pred, f) => pred(forward) ? Maybe_1.Maybe.just(f(forward)) : Maybe_1.Maybe.nothing;
exports.forwardIf = forwardIf;
const forwardTern = (forward, pred, truthy, falsy) => pred(forward) ? Either_1.Either.right(truthy(forward)) : Either_1.Either.left(falsy(forward));
exports.forwardTern = forwardTern;
const forwardIfAsync = (forward, pred, f) => __awaiter(void 0, void 0, void 0, function* () { return (yield pred(forward)) ? Maybe_1.Maybe.just(f(forward)) : Maybe_1.Maybe.nothing; });
exports.forwardIfAsync = forwardIfAsync;
const forwardTernAsync = (forward, pred, truthy, falsy) => __awaiter(void 0, void 0, void 0, function* () { return (yield pred(forward)) ? Either_1.Either.right(truthy(forward)) : Either_1.Either.left(falsy(forward)); });
exports.forwardTernAsync = forwardTernAsync;
//# sourceMappingURL=forward.js.map